import {ShortAnswer} from "../../../components/ShortAnswer";
import {Box} from "@mui/material";
import React from "react";

export const DateInput = ({
  yearRoc,
  month,
  day,
  onChangeYearRoc,
  onChangeMonth,
  onChangeDay,
}) => (
  <Box className={"flex space-between items-center gap-4"}>
    <ShortAnswer
      type="number"
      className="flex-1"
      value={yearRoc}
      onChange={e => onChangeYearRoc(e.target.value)} placeholder="民國年"
    />
    <ShortAnswer
      type="number"
      className="flex-1"
      value={month}
      onChange={e => onChangeMonth(e.target.value)}
      placeholder="月"
    />
    <ShortAnswer
      type="number"
      className="flex-1"
      value={day}
      onChange={e => onChangeDay(e.target.value)}
      placeholder="日"
    />
  </Box>
)